function login_status() {
  checkLoginStatus(); // 每次点击按钮时先检查登录状态
  if (!window.isLoggedIn) {
    $('.main_section').append(`<div class="loginRequiredMask">
          <div class="loginRequired">
              <img src="/images/index/logo_pad.svg" class="logo" alt="Logo Pad"/>
              <div class="title">${i18n[lang].public_Login_Required}</div>
              <div class="desc">${i18n[lang].public_In_order}</div>
              <div class="button">${i18n[lang].log_in}</div>
          </div>
      </div>`)
      manage('Popup_Login_View');
    $('.loginRequiredMask').on('click', function () {
      $('.main_section .loginRequiredMask').remove();
    })
    $('.loginRequired').on('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
    })
    $('.loginRequiredMask .button').on('click', function (e) {
      manage('Popup_Login_Click');
      location.href = `${lang_path}/account/login/`
    })
    return;
  } else {
    error(i18n[lang].public_Some_errors)
  }
};
//获取按钮状态
setTimeout(function () {
  getAjax(_url.getReportLabel, {lang:lang}).then(res => {
    if (res.code == 200) {
      for (var i = 0; i <res.data.length; i++) {
        if(res.data[i].status==1){
          $('#report_form .title').before(`<label for="report_${res.data[i].id}"><input id="report_${res.data[i].id}" type="radio" name="report" />${res.data[i].title}</label>`);
        }
      };
    } else {
      error(i18n[lang].public_Something_wrong);
    }
  });
},3000);
$('#report_form').on('submit', function(e){
  // 阻止表单默认提交行为
  e.preventDefault();
  $('#report_btn').html('<img src="/images/account/loading.svg" alt="Loading">');
  var _flag = true;
  // 点击提交按钮，获取所选的报表id
  let roleid = $('#report_form').attr('role_id');
  let banwords_id;
  $('input[name="report"]:checked')&&$('input[name="report"]:checked').attr('id')?banwords_id = $('input[name="report"]:checked').attr('id').replace('report_',''):banwords_id=null;
  let detail_content = $('#report_info').val();
  // 执行报表提交操作
  if(!banwords_id){
    _flag= false;
    $('#select_title').after(`<p class="info info_tip"></p>`);
    $('.info_tip').html(i18n[lang].public_select_reason);
    $('.info_tip').css('top',document.getElementById('select_title').offsetTop+$('#select_title').height()-2);
    //查看提示文字是多少行
    var num=Math.round($('.info_tip').height()/parseFloat($('.info_tip').css('line-height')))
    if(num>1&&$(window).width()>560){
        $('#select_title').css({
          marginBottom:$('.info_tip').height()+$('#select_title').height()
        })
    };
    $('#report_btn').html(i18n[lang].public_Submit);
  }else{
    $('.info_tip').remove();
  };
  if(_flag){
    getAjax(_url.addReport, {
      "roleid": roleid,
      "banwords_id": banwords_id,
      "detail_content": detail_content,
    }).then(res => {
      $('#report_btn').html(i18n[lang].public_Submit);
      $('.report_zoon').removeClass('active');
      $('#report_info').val('');
      $('#report_num').html('0');
      $('.report_zoon input').prop('checked',false);
      if (res.code == 200) {
        report_toast ('success',i18n[lang].public_Successful_report1,i18n[lang].public_Successful_report);
      } else if (res.code == 2017||res.code == '2017') {
        report_toast ('error',i18n[lang].public_Reported_too_often1,i18n[lang].public_Reported_too_often);
      } else if (res.code == 2016||res.code == '2016') {
        report_toast ('error',i18n[lang].public_Failed_report,i18n[lang].public_length_characters_1000);
      } else {
        error(i18n[lang].public_Network_error)
      }
    });
  }
});
$('.report_zoon .report_close,.report_zoon .report_cancel,.report_tip_mask .report_close').on('click', function (e) {
  e.stopPropagation();
  $('.report_zoon').removeClass('active');
  $('.report_tip_mask').removeClass('active');
  $('body').removeClass('hide');
  $('.more_functions .report').removeClass('active');
  $('#report_info').val('');
  $('.report_zoon input').prop('checked',false);
  $('#report_num').html('0');
});
$('.more_functions .report,.more_functions .report').on('click', function () {
  $(this).toggleClass('active');
});
$('#report_info').on('input',function(){
  $('#report_num').html($(this).val().length);
  if($(this).val().length>1000){
    $('#textarea_tip').html(i18n[lang].public_length_characters_1000);
  }else{
    $('#textarea_tip').html('');
  }
});
function report_toast (type,b,c,d){
  if(type=='success'){
    $('.report_tip_mask').addClass('suc active');
    setTimeout(function(){
      $('.report_tip_mask').removeClass('suc active');
    },2000);
  }else if(type=='error'){
    $('.report_tip_mask').addClass('err active');
    setTimeout(function(){
      $('.report_tip_mask').removeClass('err active');
    },2000);
  };
  if(b){
    $('.report_tip_mask .title').html(b)
  }
  if(c){
    $('.report_tip_mask .info').html(c)
  }
};
function report_arguments(role_id,name,nsfw){
  $('body').toggleClass('hide');
  $('.report_zoon').addClass('active');
  $('#report_form').attr('role_id',role_id);
  $('.report_zoon #report_role').html(name);
  if(nsfw==1){
    $('.report_zoon label[for="report_1"]').addClass('hide');
  }else{
    $('.report_zoon label[for="report_1"]').removeClass('hide');
  }
};
$(document).on('click',function(e){
  $('.other_options').find('i').removeClass('active');
  $('.other_options').find('a').removeClass('active');
  $('.other_options').find('span').removeClass('active');
});